/**
 * 日本語メッセージ
 */

/**
 * 使い方
 * import { errors as lang_error } from '@/lang/ja_JP'
 * lang_error.timeout
 */
export const errors = {
  timeout: '通信がタイムアウトしました。',
  networkError: 'ネットワークエラーが発生しました。接続先、端末の接続状況を確認してお試しください。',
  apiCanceled: 'Request Canceled',
  validError: '入力した内容に間違いがあります。各入力項目をご確認ください。',
  importDataErrorMessages: {
    0: 'ファイルサイズが 0 バイト のファイルはインポートできません。',
    1: '拡張子が json のファイルを選択してください。',
    2: 'ファイルの中身を解析できませんでした。'
  }
}

/**
 * 使い方
 * import { fields as lang_field } from '@/lang/ja_JP'
 * lang_field.empty
 */
export const fields = {
  empty: '(なし)',
  licenseNoExample: '例) AAAAAAAAAAAA-9999',
  customerCodeExample: '例) 260XXXXXXXXXXXX'
}



// WEBPACK FOOTER //
// ./src/lang/ja_JP.js